import { ScoreCardMenu } from "@/components/ScoreCardMenu/ScoreCardMenu";
import { ScoreCardFragment } from "@/graphql/generated/graphql";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

const noop = () => {};

function makeScoreCard(
  ID: string,
  name: string,
  description: string
): ScoreCardFragment {
  return {
    __typename: "ScoreCard",
    ID,
    name,
    description,
    createdAt: "2026-06-01T00:00:00.000Z",
    createdBy: "playground",
    isPublished: true,
    language: "en",
    categories: [],
  };
}

const SCORECARDS: ScoreCardFragment[] = [
  makeScoreCard("1", "Mehmet Test", "Testing playbook"),
  makeScoreCard("2", "Marian Test (1 AI disabled question)", ""),
  makeScoreCard("3", "Test Daily", "Foo"),
  makeScoreCard("4", "Luis Test NA", ""),
  makeScoreCard("5", "Sales Test Nico", "Outbound sales call quality"),
];

export function PlaygroundReviewScorecards() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Scorecard selector (panel / outline style)
        </PlaygroundSubSectionTitle>
        <div className="h-[420px] w-[420px]">
          <ScoreCardMenu data={SCORECARDS} onClickItem={noop} />
        </div>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
